<template>
  <form
    @submit.prevent="login"
    class="login-form form rounded border border-warning">
    <h3>Sign In</h3>
    <div class="form-group">
      <label>Email Address</label>
      <input
        class="form-control"
        type="email"
        placeholder="Email"
        v-model="email"
      />
    </div>
    <div class="form-group">
      <label>Password</label>
      <input
        class="form-control"
        type="password"
        placeholder="Pasword"
        v-model="password"
      />
    </div>
    <button class="btn btn-warning btn-block">Log In</button>
    <p class="small">Don't have an account? You can <router-link to="/sign-up">create one</router-link>.</p>
    <p class="alert alert-danger" v-if="errorMessage">{{ errorMessage }}</p>
  </form>
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'login',
  data() {
    return {
      email: '',
      password: '',
      errorMessage: ''
    };
  },
  methods: {
    login() {
      firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
        (user) => {
          this.$router.replace('home');
        },
        (err) => {
          this.errorMessage = err.message;
        }
      );
    }
  }
};
</script>
